import styled from 'styled-components';

const DesignPageContainer = styled.div`
    padding-top: var(--section-padding);
    padding-bottom: var(--section-padding);
    height: 600px;
    position: relative;
    background-image: url('https://i.ibb.co/FK2p4Dm/design-features.jpg');
    background-size: cover;
    display: flex;
    align-items: center;
    overflow: hidden;
    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgb(0 0 0 / 60%);
    }
    .image,
    .text {
        position: relative;
        z-index: 2;
        flex: 1;
    }
    .image {
        text-align: center;
        @media (max-width: 767px) {
            display: none;
        }
        img {
            position: relative;
            bottom: -150px;
        }
    }
    .text {
        color: white;
        padding: 50px;
        background-color: var(--transparent-color);
        h2 {
            font-weight: normal;
            text-transform: uppercase;
            margin-bottom: 40px;
        }
        ul li {
            padding: 15px 0;
            &::before {
                font-family: 'Font Awesome 5 Free';
                content: '\f108';
                font-weight: 900;
                margin-right: 20px;
                position: relative;
                top: 1px;
            }
        }
    }
`;

export default DesignPageContainer;
